export default __webpack_public_path__ + "img/pin_icons/fire_pump_b.png";